import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.page.html',
  styleUrls: ['./notification.page.scss'],
})
export class NotificationPage implements OnInit {

  constructor(private platform: Platform,private router:Router,private storage: Storage) {
  }

  ngOnInit() {
  }




  ionViewWillEnter(){


    this.platform.backButton.subscribeWithPriority(1, () => {
      this.router.navigate(['tabs/tab1']);
});



    this.storage.get('tokenData').then((val) => {
      console.log('tokenData', val);
      if (!val) {
          this.router.navigate(["login"]);
      }
  }); 

  }

}
